import { ReactElement } from 'react'

import { Link } from 'react-router-dom'

import { Flex } from 'components/core'
import { AUTO } from 'const/targetingTypes'
import { formatMatchType } from 'helpers/formatting'
import { keywordUrl } from 'routing/urls'

import { SelectedSearchTerm } from '../localTypes'
import * as styles from '../styles.scss'

interface Props {
    selectedSearchTerm: SelectedSearchTerm
}

const isKeywordSearchTerm = (searchTerm: SelectedSearchTerm): boolean =>
    !!searchTerm.record.keyword

const isAutoCampaign = (searchTerm: SelectedSearchTerm): boolean =>
    searchTerm.record.campaign.targeting_type === AUTO

const KeywordLabel = ({ selectedSearchTerm }: Props): ReactElement | null => {
    if (
        isKeywordSearchTerm(selectedSearchTerm) &&
        !isAutoCampaign(selectedSearchTerm)
    ) {
        const {
            record: {
                keyword: {
                    id: keywordId,
                    text: keywordText,
                    match_type: keywordMatchType,
                },
            },
        } = selectedSearchTerm
        return (
            <Flex direction="column" alignItems="normal">
                <div className={styles.label}>Source Keyword</div>
                <div className={styles.value}>
                    <Link to={keywordUrl(keywordId)}>{keywordText}</Link> (
                    {formatMatchType(keywordMatchType)})
                </div>
            </Flex>
        )
    }
    return null
}

export default KeywordLabel
